import EdsCategoryCloseAllEvent from '@/features/eds/components/EdsCategories/events/EdsCategoryCloseAllEvent';
import EdsCategoryCloseAllOverviewsEvent from '@/features/eds/components/EdsCategories/events/EdsCategoryCloseAllOverviewsEvent';
import EdsCategoryCloseEvent from '@/features/eds/components/EdsCategories/events/EdsCategoryCloseEvent';
import EdsCategoryCloseRestEvent from '@/features/eds/components/EdsCategories/events/EdsCategoryCloseRestEvent';
import EdsCategoryOpenAllEvent from '@/features/eds/components/EdsCategories/events/EdsCategoryOpenAllEvent';
import EdsCategoryOpenAllOverviewsEvent from '@/features/eds/components/EdsCategories/events/EdsCategoryOpenAllOverviewsEvent';
import EdsCategoryOpenRestEvent from '@/features/eds/components/EdsCategories/events/EdsCategoryOpenRestEvent';
import EdsCategoryToggleEvent from '@/features/eds/components/EdsCategories/events/EdsCategoryToggleEvent';
import EdsCategoryOpenEvent from './EdsCategoryOpenEvent';

const EdsCategoryEvents = {
  Open: EdsCategoryOpenEvent,
  Close: EdsCategoryCloseEvent,
  Toggle: EdsCategoryToggleEvent,
  OpenAll: EdsCategoryOpenAllEvent,
  CloseAll: EdsCategoryCloseAllEvent,
  OpenAllOverviews: EdsCategoryOpenAllOverviewsEvent,
  OpenRest: EdsCategoryOpenRestEvent,
  CloseRest: EdsCategoryCloseRestEvent,
  CloseAllOverviews: EdsCategoryCloseAllOverviewsEvent,
};

export default EdsCategoryEvents;
